<template>
  <div class="table-cell-lambda-log-memory">{{ memory }}</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { LambdaLog } from '@models';

import bytes from 'bytes';

/**
 * `TableCellLambdaLogMemory` component properties.
 */
export interface Props {
  item: LambdaLog;
}

const props = defineProps<Props>();

const memory = computed(() => {
  return `${bytes(props.item.memory)} / ${bytes(props.item.memoryUsed)}`;
});
</script>

<script lang="ts">
declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellLambdaLogMemory: ComponentWithProps<Props>;
  }
}

export default { name: 'TableCellLambdaLogMemory' };
</script>

<style scoped lang="scss"></style>
